/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Redemption
 */
export interface Redemption {
    /**
     * 
     * @type {string}
     * @memberof Redemption
     */
    voucherCode: string;
}

/**
 * Check if a given object implements the Redemption interface.
 */
export function instanceOfRedemption(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "voucherCode" in value;

    return isInstance;
}

export function RedemptionFromJSON(json: any): Redemption {
    return RedemptionFromJSONTyped(json, false);
}

export function RedemptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Redemption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'voucherCode': json['voucherCode'],
    };
}

export function RedemptionToJSON(value?: Redemption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'voucherCode': value.voucherCode,
    };
}

